import { UPDATE_AUDIT_TEMPLATE } from "redux/types";
import client from "graphql/client";
import { loader } from "graphql.macro";
const updateAuditTemplateMutation = loader("graphql/mutations/auditTemplates/addAuditTemplate.graphql");

export const updateAuditTemplate = (templateData) => {
    return async (dispatch) => {
        try {

            const cleanedData = { ...templateData };

            if (cleanedData.id === "") {
                delete cleanedData.id;
            }


            const { data } = await client.mutate({
                mutation: updateAuditTemplateMutation,
                variables: {
                    auditTemplate: cleanedData,
                },
            });

            dispatch({
                type: UPDATE_AUDIT_TEMPLATE,
                payload: data.updateAuditTemplate,
            });

        } catch (error) {
            console.error("Failed to update audit template:", error);
        }
    };
};